import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const container = css`
  display: inline-flex;
  padding: 0 10px;
  border-radius: 3px;
  background-color: ${colors.custom.primary10};
  color: ${colors.gray.dark};
  align-items: center;
  height: 27px;
  box-sizing: border-box;
`;

export const value = css`
  margin-left: 10px;
  font-weight: ${fonts.weight.bold};
  color: ${colors.primary.default};
`;

export const suffix = css`
  color: ${colors.primary.default};
`;

export const icon = css`
  height: 12px;
  width: 12px;
`;
